import React from "react";
import { Trans } from "@lingui/macro";

export const TitleForm = <Trans id="signin.form.title">Sign In</Trans>;
export const BtnTitle = <Trans id="signin.actionButton.submit">Sign In</Trans>;
